import { tns } from 'tiny-slider/src/tiny-slider';

class PostsSlider {
	constructor(el) {
		console.log('testing');
		this.el = el;

		const sliderContainer = this.el.querySelector('.block-posts-slider__slider-wrapper');
		const nextButton = this.el.querySelector('.block-posts-slider__next-btn');
		const prevButton = this.el.querySelector('.block-posts-slider__prev-btn');

		const blockSlider = tns({
			container: sliderContainer,
			controls: true,
			prevButton: prevButton,
			nextButton: nextButton,
			nav: false,
			autoHeight: true,
			axis: 'horizontal',
			swipeAngle: false,
			speed: 400,
			mouseDrag: true,
			autoplay: false,
			autoplayButtonOutput: false,
			slideBy: 1,
			items: 1,
			edgePadding: 0,
			gutter: 20,
			responsive: {
				768: {
					items: 2,
					gutter: 20
				},
				1024: {
					items: 3,
					gutter: 40
				}
			}
		});
		this.normalizeSlides();

		blockSlider.events.on('transitionStart', () => this.normalizeSlides());
		window.addEventListener('resize', () => this.normalizeSlides());
	}

	normalizeSlides() {
		const slides = this.el.querySelectorAll('.block-posts-slider__slide');
		slides.forEach((slide) => {
			slide.setAttribute('style', '');
		});

		let maxHeight = 0;
		slides.forEach((slide) => {
			const slideHeight = slide.clientHeight;
			if(slideHeight > maxHeight) {
				maxHeight = slideHeight;
			}
		});

		slides.forEach((slide) => {
			slide.setAttribute('style', 'height: ' + maxHeight + 'px');
		});
	}
}

export default PostsSlider;
